import Notification from '../../application/core/Notification';

const notificationFilter = (allNotifications: Notification[]): Notification[] => {
    const duplicatedNotifications: string[] = [];

    allNotifications.forEach((notification: Notification) => {
        const duplicates: string[] = allNotifications
            .filter((elem: Notification) => {
                return (
                    elem.data.message === notification.data.message && elem.data.preventDuplicates && notification.data.preventDuplicates
                );
            })
            .map((elem: Notification) => elem.id);

        if (duplicates.length > 0 && !duplicatedNotifications.includes(notification.id)) {
            duplicates.forEach((duplicatedId: string) => {
                if (!duplicatedNotifications.includes(duplicatedId) && duplicatedId !== notification.id) {
                    duplicatedNotifications.push(duplicatedId);
                }
            });
        }
    });

    const uniqueOnly = (notification: Notification): boolean => {
        return !duplicatedNotifications.includes(notification.id);
    };

    return allNotifications.filter(uniqueOnly);
};

export default notificationFilter;



// WEBPACK FOOTER //
// ./src/view/notifications/NotificationFilter.ts